module.exports = __webpack_public_path__ + "static/media/logo-dieetclub.8ecda12c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-dieetclub.png
// module id = 95
// module chunks = 0